module.exports = __webpack_public_path__ + "img/downsort.a8354f3f.svg";